<template>
  <div class="preview__container" v-on="$listeners">
    <div class="preview-info">
      <div class="preview-info__header">
        <span class="preview__title">{{ dialogTitle }}</span>
        <span class="text-mr text-tertiary">{{ time }}</span>
      </div>
      <div v-if="lastMessage">
        <div class="preview__last-name">
          {{ lastMessage.user.name }}
        </div>
        <div class="preview__text-container spacex-4">
          <div class="preview__text">
            {{ lastMessagePreview }}
          </div>
          <div v-if="offer.unread_messages_count" class="chat-counter">
            {{ offer.unread_messages_count }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import get from 'lodash.get';
  import { mapState } from 'vuex';
  import time from '@/utils/date/time';

  export default {
    name: 'DialogPreview',
    props: {
      offer: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['tenderOfferStatuses']),
      dialogTitle() {
        return get(this.offer, 'contractor_team.name', '');
      },
      lastMessage() {
        return get(this.offer, 'last_message', null);
      },
      lastMessagePreview() {
        return this.lastMessage.files.length
          ? this.lastMessage?.files?.[0]?.name
          : this.lastMessage.message;
      },
      time() {
        return this.lastMessage?.created_at ? time(this.lastMessage?.created_at) : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .preview__container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 8px;
    cursor: pointer;
    padding: 12px;
    transition: background-color 0.2s ease;
    background-color: white;
    position: relative;
  }

  .preview-info {
    width: 100%;
  }

  .preview__title {
    color: $grey900;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 4px;
  }

  .preview__last-name {
    color: $grey900;
    font-weight: 500;
    font-size: 14px;
  }

  .preview__text {
    color: $text-tertiary;
    font-weight: 400;
    font-size: 14px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .preview__text-container {
    display: flex;
    justify-content: space-between;
  }

  .chat-counter {
    background: $primary500;
    color: white;
    padding: 0 6px;
    width: fit-content;
    border-radius: 99px;
  }

  .preview__status {
    margin-top: 4px;
    background-color: $primary50;
    border: 1px solid #dadde2;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 8px;
    color: $grey900;
    font-weight: 500;
    width: fit-content;
  }

  .preview-info__header {
    display: flex;
    justify-content: space-between;
  }
</style>
